import { UtcDateString } from './date-types'

export enum StatusStyleCode {
    Red = 'red',
    Yellow = 'yellow',
    Green = 'green',
    Blue = 'blue',
    White = 'white',
    Black = 'black',
    Gray = 'gray',
    Unknown = 'unknown',
}



export type EntityStatus<T = string> = {
    code: T,
    name: string,
    changedAtUtc: UtcDateString,
    changedBy: number,
    props: {
        styleCode: StatusStyleCode,
    },
}